<template>
  <section>
    <div class="tip" style="margin:25px 0 0 20px">* 项目基本资料</div>
    <ul class="project-info-list" v-if="project">
      <li>
        <label>项目名称：</label>
        <div class="info-item">{{ project.name }}</div>
      </li>
      <li>
        <label>项目需求单位：</label>
        <div class="info-item">{{ project.deptName?project.deptName:project.departmentVO.name }}</div>
      </li>
      <li>
        <label>代理单位：</label>
        <div class="info-item">{{ form.dldw }}</div>
      </li>
      <li>
        <label>招标方式：</label>
        <div class="info-item">{{ form.mode }}</div>
      </li>
      <li class="block intro-box">
        <label>招标内容：</label>
        <div class="info-item">{{ form.content }}</div>
      </li>
    </ul>

  </section>
</template>
<script>
  export default {
    props: ['form', 'userData', 'project'],
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>


// WEBPACK FOOTER //
// src/page/user/projectinfo/createInviteApproval.vue